import './_three-cards-section.scss';
document.addEventListener('DOMContentLoaded', () => {
  var sections = document.querySelectorAll('[data-section-type="feature-cards"]');
  if (!sections.length) return;
  sections.forEach(section => {
    var enableToggle = section.dataset.enableToggle === 'true';
    var tabButtons = section.querySelectorAll('[data-toggle-trigger]');
    var panels = section.querySelectorAll('[data-toggle-panel]');
    var cardToggleButtons = section.querySelectorAll('[data-card-toggle]');
    var closeCard = button => {
      var card = button.closest('[data-card]');
      var contentId = button.getAttribute('aria-controls');
      var content = contentId ? document.getElementById(contentId) : null;
      button.setAttribute('aria-expanded', 'false');
      if (card) {
        card.classList.remove('is-open');
        card.style.setProperty('--feature-card-shift', '0px');
      }
      if (content) {
        content.setAttribute('aria-hidden', 'true');
        content.style.maxHeight = '0px';
      }
    };
    var closeCardsInsidePanel = panel => {
      if (!panel) return;
      var panelCardButtons = panel.querySelectorAll('[data-card-toggle]');
      panelCardButtons.forEach(closeCard);
    };
    var setActiveState = state => {
      tabButtons.forEach(button => {
        var isActive = button.dataset.toggleTrigger === state;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
        button.setAttribute('tabindex', isActive ? '0' : '-1');
      });
      panels.forEach(panel => {
        var isActive = panel.dataset.togglePanel === state;
        panel.classList.toggle('is-active', isActive);
        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
          closeCardsInsidePanel(panel);
        }
      });
      section.classList.toggle('is-secondary-state', state === 'secondary');
    };
    var toggleCard = button => {
      var card = button.closest('[data-card]');
      var contentId = button.getAttribute('aria-controls');
      var content = contentId ? document.getElementById(contentId) : null;
      var description = content === null || content === void 0 ? void 0 : content.querySelector('.feature-card__description');
      var isOpen = button.getAttribute('aria-expanded') === 'true';
      if (!card || !content || !description) return;
      button.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      card.classList.toggle('is-open', !isOpen);
      content.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
      if (isOpen) {
        content.style.maxHeight = '0px';
        card.style.setProperty('--feature-card-shift', '0px');
        return;
      }
      requestAnimationFrame(() => {
        var descriptionHeight = description.scrollHeight;
        content.style.maxHeight = "".concat(descriptionHeight, "px");
        card.style.setProperty('--feature-card-shift', "".concat(descriptionHeight, "px"));
      });
    };
    if (enableToggle && tabButtons.length) {
      setActiveState('primary');
      tabButtons.forEach(button => {
        button.addEventListener('click', () => {
          setActiveState(button.dataset.toggleTrigger);
        });
      });
    }
    cardToggleButtons.forEach(button => {
      button.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        toggleCard(button);
      });
    });
  });
});